import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { FinishedGoodsTemplateGridComponent } from "../finished-goods-template-grid/finished-goods-template-grid.component";
import { v4 as uuidv4 } from "uuid";
import { FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ServiceTemplateGridComponent } from "../service-template-grid/service-template-grid.component";
import { AddAndUpdateFinishedGoodsTemplateDto } from "../../../core/models/inventoryPurchases/addAndUpdateFinishedGoodsTemplateDto";
import { FinishedGoodsTemplateHeader } from "../../../core/models/inventoryPurchases/finishedGoodsTemplateHeader";
import { InventoryPurchaseService } from "../../../core/services/inventory-purchase.service";
import { ReleasedProductVariants } from "../../../core/models/shared/releasedProductVariants";
import { ReleasedProduct } from "../../../core/models/shared/releaseProduct";
import { LoaderService } from "../../../core/services/loader.service";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import { SamplepoListingService } from "../../../core/services/samplepo-listing.service";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { SelectModule } from "primeng/select";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { TemplateServiceLineFormComponent } from "../template-service-line-form/template-service-line-form.component";
import { PurchaseOrderLine } from "../../../core/models/samplePO/details/purchaseOrderLine";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { CommonModule } from "@angular/common";
import { SelectButtonChangeEvent } from "primeng/selectbutton";

@Component({
  selector: "jni-create-finished-goods-template",
  templateUrl: "./create-finished-goods-template.component.html",
  styleUrls: ["./create-finished-goods-template.component.scss"],
  imports: [
    FormsModule,
    SelectModule,
    ModalStackerComponent,
    TemplateServiceLineFormComponent,
    ServiceTemplateGridComponent,
    FinishedGoodsTemplateGridComponent,
    ReactiveFormsModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    CheckboxModule,
    CommonModule,
  ],
})
@UntilDestroy()
export class CreateFinishedGoodsTemplateComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() saleOrderIdFromModal = "";
  @Input() lineGroup = "";
  @Input() site = "";
  @Input() warehouse = "";
  @Input() jobNameD365 = "";
  @Input() wMSLocationD365 = "";
  @Input() ownerD365 = "";
  @Input() saleOrderModalStatus = false;
  @Input() store = "";
  allTemplates: FinishedGoodsTemplateHeader[] = [];
  @Output() refreshGridEmit = new EventEmitter();
  @Output() closeModalEmit = new EventEmitter();

  templateName = "";
  itemType = "";
  index!: number | null;
  itemNumber = "";
  itemTypeList: string[] = [];
  itemNumbers: string[] = [];
  items: {
    itemNumber: string | null;
    name: string | null;
  }[] = [];
  size = false;
  color = false;
  fit = false;
  vendorReference = "";
  releasedProductsList: ReleasedProduct[] = [];
  allReleasedProductsList: ReleasedProduct[] = [];
  releasedProductsVariantsList: ReleasedProductVariants[] = [];
  allReleasedProductsVariantsList: ReleasedProductVariants[] = [];
  filteredFinishedGoodsList: PurchaseOrderLine[] = [];
  inventoryServiceLinesDisplayModal = false;
  serviceLineToEdit!: PurchaseOrderLine;

  @ViewChild("finishedGoodsTemplateGrid", { static: false })
  finishedGoodsTemplateGrid!: FinishedGoodsTemplateGridComponent;

  @ViewChild("servicesTemplateGrid", { static: false })
  servicesTemplateGrid!: ServiceTemplateGridComponent;

  constructor(
    private _orderSummaryService: OrderSummaryService,
    private _samplepoListingService: SamplepoListingService,
    private _loader: LoaderService,
    private _inventoryPurchaseService: InventoryPurchaseService,
    private _toastr: JniToastrService
  ) {}

  ngOnInit(): void {
    this.getAllReleaseProduct();
    this.getAllVariants();
    this.getFinishedGoodsTemplateNames();
  }

  getAllReleaseProduct() {
    this._orderSummaryService
      .getAllCategory()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.allReleasedProductsList = res.data?.filter(
            x => x.productTypeD365 !== "Service" && x.poStopped === "No"
          );

          this.finishedGoodsTemplateGrid.allReleasedProductsList =
            this.allReleasedProductsList;

          this.itemTypeList = [
            ...new Set(
              this.allReleasedProductsList
                .filter(x => x.itemTypeD365)
                .map(x => x.itemTypeD365 ?? "")
            ),
          ];

          this.releasedProductsList = [
            ...this.allReleasedProductsList.filter(
              x => x.ownerD365 == this.ownerD365
            ),
          ];

          this.finishedGoodsTemplateGrid.releasedProductsList =
            this.releasedProductsList;

          // this.releasedProductsList = this.allReleasedProductsList?.filter(
          //   (x) => x.ownerD365 == this.owner
          // );
        },
      });
  }

  getAllVariants() {
    this._loader.setLoaderState(true);
    this._samplepoListingService
      .getAllVariants()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          this.allReleasedProductsVariantsList = res.data.filter(
            item => item.poStopped === "No"
          );
          this.releasedProductsVariantsList = [
            ...this.allReleasedProductsVariantsList,
          ];

          this.finishedGoodsTemplateGrid.releasedProductsVariantsList =
            this.releasedProductsVariantsList;

          this.setItemNumbers();
        },
      });
  }

  itemTypeChange(value: string) {
    this.itemType = value;
    this.setItemNumbers();
  }

  itemNumberChange(value: SelectButtonChangeEvent) {
    this.itemNumber = value.value;
    this.filterFinishGoods(value.value);
  }

  filterNumberAndFinishedGoods() {
    this.setItemNumbers();
    this.filterFinishGoods();
  }

  setItemNumbers() {
    this.releasedProductsList = this.allReleasedProductsList.filter(
      x => x.ownerD365 == this.ownerD365
    );

    this.itemNumbers = this.releasedProductsList.map(
      x => x.itemNumberD365 ?? ""
    );

    this.items = this.releasedProductsList.map(x => ({
      itemNumber: x.itemNumberD365,
      name: x.nameD365,
    }));

    if (this.size || this.color || this.fit) {
      let variants = this.allReleasedProductsVariantsList.filter(x =>
        this.itemNumbers.includes(x.itemIdD365)
      );

      if (this.size) {
        variants = variants.filter(x => x.sizeD365);
      }
      if (this.color) {
        variants = variants.filter(x => x.colorD365);
      }
      if (this.fit) {
        variants = variants.filter(x => x.styleD365);
      }

      const variantsItemId = [...new Set(variants.map(x => x.itemIdD365))];

      this.items = this.allReleasedProductsList
        .filter(x => variantsItemId.includes(x.itemNumberD365 ?? ""))
        .map(x => ({
          itemNumber: x.itemNumberD365,
          name: x.nameD365,
        }));

      this.itemNumbers = this.items.map(x => x.itemNumber ?? "");
    }
  }

  filterFinishGoods(value?: string) {
    this.releasedProductsVariantsList =
      this.allReleasedProductsVariantsList.filter(x =>
        this.itemNumbers.includes(x.itemIdD365)
      );

    this.releasedProductsVariantsList =
      this.allReleasedProductsVariantsList.filter(
        x => x.itemIdD365 === this.itemNumber
      );

    const filterProducts = value ?? this.itemNumber;
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList =
      this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.filter(
        item => item.itemNumberD365 === filterProducts
      );

    if (this.size) {
      this.releasedProductsVariantsList =
        this.releasedProductsVariantsList.filter(x => x.sizeD365);
    }
    if (this.color) {
      this.releasedProductsVariantsList =
        this.releasedProductsVariantsList.filter(x => x.colorD365);
    }
    if (this.fit) {
      this.releasedProductsVariantsList =
        this.releasedProductsVariantsList.filter(x => x.styleD365);
    }

    this.setTemplateName();
  }

  addAllVariants() {
    if (this.itemNumber) {
      this.filterFinishGoods();
    } else {
      this.releasedProductsVariantsList = [
        ...this.allReleasedProductsVariantsList,
      ];
    }
    //const releasedProd = this.allReleasedProductsList.filter((item) => item.itemNumberD365 === this.itemNumber)[0];
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList = [];
    this.releasedProductsVariantsList.sort((a, b) => {
      // First, compare by styleDisplayOrderD365
      if (a.styleDisplayOrderD365 !== b.styleDisplayOrderD365) {
        return a.styleDisplayOrderD365 - b.styleDisplayOrderD365;
      }

      // If styleDisplayOrderD365 is the same, compare by colorDisplayOrderD365
      if (a.colorDisplayOrderD365 !== b.colorDisplayOrderD365) {
        return a.colorDisplayOrderD365 - b.colorDisplayOrderD365;
      }

      // If both styleDisplayOrderD365 and colorDisplayOrderD365 are the same, compare by sizeGlobalDisplayOrderD365
      return a.sizeGlobalDisplayOrderD365 - b.sizeGlobalDisplayOrderD365;
    });

    if (this.releasedProductsVariantsList.length === 0) {
      this.productsWithNoVariant();
      return;
    }
    for (const variant of this.releasedProductsVariantsList) {
      const object = {
        id: 0,
        lineRecIdD365: null,
        // siteD365: this.site,
        // warehouseD365: this.warehouse,
        portalKeyD365: uuidv4(),
        parentD365: true,
        // lineGroupD365: this.selectedLineGroup,
        // purchaseOrderNumberD365: this.purchaseOrderNumber,
        // jobNameD365: this.parent.get('jobName')?.value,
        // wMSLocationD365: this.parent.get('location')?.value,
        orderedPurchaseQuantityD365: 0,
        purchasePriceD365: 0,
        lineAmountD365: 0,
        purchaseUnitSymbolD365: "ea",
        itemNumberD365: variant.itemIdD365,
        styleD365: variant.styleD365,
        sizeD365: variant.sizeD365,
        colorD365: variant.colorD365,
        productNameD365: variant.nameD365,
        mockSellD365: 0,
        mockSellTotalD365: 0,
      } as PurchaseOrderLine;

      this.finishedGoodsTemplateGrid.generateDescription(object);
      this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.push(object);
    }
  }

  productsWithNoVariant() {
    const prod = this.allReleasedProductsList.find(
      item => item.itemNumberD365 === this.itemNumber
    );
    const object = {
      id: 0,
      lineRecIdD365: null,
      // siteD365: this.site,
      // warehouseD365: this.warehouse,
      portalKeyD365: uuidv4(),
      parentD365: true,
      // lineGroupD365: this.selectedLineGroup,
      // purchaseOrderNumberD365: this.purchaseOrderNumber,
      // jobNameD365: this.parent.get('jobName')?.value,
      // wMSLocationD365: this.parent.get('location')?.value,
      orderedPurchaseQuantityD365: 0,
      purchasePriceD365: 0,
      lineAmountD365: 0,
      purchaseUnitSymbolD365: "ea",
      itemNumberD365: prod?.itemNumberD365 ?? "",
      styleD365: "",
      sizeD365: "",
      colorD365: "",
      productNameD365: prod?.nameD365 ?? "",
      mockSellD365: 0,
      mockSellTotalD365: 0,
    } as PurchaseOrderLine;

    this.finishedGoodsTemplateGrid.generateDescription(object);
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.push(object);
  }

  setTemplateName() {
    const item = this.releasedProductsVariantsList[0];

    if (this.releasedProductsVariantsList.length === 0) {
      const prod = this.allReleasedProductsList.find(
        item => item.itemNumberD365 === this.itemNumber
      );
      const itemNumber = prod?.itemNumberD365;
      const productName = prod?.nameD365;

      this.templateName = "";
      this.templateName = itemNumber
        ? `${this.templateName}${itemNumber}`
        : `${this.templateName}`;

      this.templateName = productName
        ? `${this.templateName}-${productName}`
        : `${this.templateName}`;

      this.templateName = this.vendorReference
        ? `${this.templateName}-${this.vendorReference}`
        : `${this.templateName}`;
    } else {
      const itemNumber = item?.itemIdD365;
      const productName = item?.nameD365;

      this.templateName = "";
      this.templateName = itemNumber
        ? `${this.templateName}${itemNumber}`
        : `${this.templateName}`;

      this.templateName = productName
        ? `${this.templateName}-${productName}`
        : `${this.templateName}`;

      this.templateName = this.vendorReference
        ? `${this.templateName}-${this.vendorReference}`
        : `${this.templateName}`;
    }
  }

  closeModalFromInventoryServiceLines() {
    this.inventoryServiceLinesDisplayModal = false;
  }

  closeModal() {
    this.closeModalEmit.emit();
    this.refreshGridEmit.emit();
  }

  addNewServiceLine() {
    this.index = null;

    this.serviceLineToEdit = {} as PurchaseOrderLine;
    this.inventoryServiceLinesDisplayModal = true;
  }

  editServiceLine([line, index]: [PurchaseOrderLine, number]) {
    this.serviceLineToEdit = line;
    this.index = index;
    this.inventoryServiceLinesDisplayModal = true;
  }

  editedServiceLine([lines]: [PurchaseOrderLine]) {
    if (this.index != null) {
      this.servicesTemplateGrid.filteredServiceLines[this.index] = lines;
      this.serviceLineToEdit = {} as PurchaseOrderLine;
    }
  }

  serviceLines(lines: PurchaseOrderLine[]) {
    this.servicesTemplateGrid.filteredServiceLines.push(...lines);
    // this._toastr.success("Success", "Line Added Successfully");
  }
  isDuplicateTemplateName(name: string) {
    const template = this.allTemplates.find(x => x.name === name);
    if (template) {
      return true;
    }
    return false;
  }
  createTemplate() {
    if (!this.itemNumber) {
      this._toastr.error("No item number selected.", "Error");
      return;
    }
    if (this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.length < 1) {
      this._toastr.error("No finished good added.", "Error");
      return;
    }
    this.calculateNet();

    if (this.isDuplicateTemplateName(this.templateName)) {
      this._toastr.error(
        "Template name already exists. Use a different name.",
        "Error"
      );

      return;
    }

    const isZeroQuantity =
      this.servicesTemplateGrid.filteredServiceLines.filter(
        item =>
          !item.orderedPurchaseQuantityD365 ||
          item.orderedPurchaseQuantityD365 < 1
      );

    if (isZeroQuantity.length > 0) {
      this._toastr.error("Error", "ZERO quantity not allowed for Services");
      return;
    }

    const header = {
      color: this.color,
      fit: this.fit,
      size: this.size,
      itemType: this.itemType,
      name: this.templateName,
      vendorReference: this.vendorReference,
      store: this.store,
      owner: this.ownerD365,
      itemNumber: this.itemNumber,
      id: 0,
    } as FinishedGoodsTemplateHeader;

    const lines = [
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
      ...this.servicesTemplateGrid.filteredServiceLines,
    ];

    const linesTemplate = [];
    for (const line of lines) {
      const templateLine = { ...line };
      linesTemplate.push(templateLine);
    }

    const duplicateLineSet = this.checkDuplicateItem([
      ...this.finishedGoodsTemplateGrid.filteredFinishedGoodsList,
    ]);

    if (duplicateLineSet.size > 0) {
      this._toastr.error(
        "Error",
        `Duplicate item variants: ${[...duplicateLineSet].join("; ")}.`
      );
      return;
    }

    const request = {
      finishedGoodsTemplateHeader: header,
      finishedGoodsTemplateLines: linesTemplate,
    } as AddAndUpdateFinishedGoodsTemplateDto;

    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .addAndUpdateFinishedGoodsTemplate(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loader.setLoaderState(false);
          if (res.data) {
            this._toastr.success("Template Created", "Success");
            this.createLines(lines);
          } else {
            this._toastr.error("Error while creating template", "Error");
          }
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while creating template",
            "Error"
          );
        },
      });
  }

  getFinishedGoodsTemplateNames() {
    this._loader.setLoaderState(true);
    this._inventoryPurchaseService
      .getFinishedGoodsTemplateNames()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: GenericResponseDto<FinishedGoodsTemplateHeader[]>) => {
          this._loader.setLoaderState(false);
          this.allTemplates = res.data.filter(x => x.store == this.store);
        },
        error: () => {
          this._loader.setLoaderState(false);
          this._toastr.error(
            "Something went wrong while fetching templates",
            "Error"
          );
        },
      });
  }

  createLines(lines: PurchaseOrderLine[]) {
    for (const line of lines) {
      line.siteD365 = this.site;
      line.lineGroupD365 = this.lineGroup;
      line.warehouseD365 = this.warehouse;
      line.purchaseOrderNumberD365 = this.saleOrderIdFromModal;
      line.jobNameD365 = this.jobNameD365;
      line.wMSLocationD365 = this.wMSLocationD365;
      line.purchaseUnitSymbolD365 = "ea";
      line.requestedShippingDateD365 = null;
      line.requestedDeliveryDateD365 = null;
      if (line.parentD365) {
        line.purchasePriceD365 = line.purchasePriceD365 ?? 0;
        line.lineAmountD365 = line.lineAmountD365 ?? 0;
      }
    }

    if (!lines?.length) {
      this._toastr.error("No finished goods found.", "Error");
      return;
    }

    this._loader.setLoaderState(true);
    if (lines.length > 0) {
      lines.forEach((value: PurchaseOrderLine) => {
        value.rsmFirmD365 = value.rsmFirmD365?.toString() ?? "false";
      });
    }
    this._samplepoListingService.addLineGroup(lines).subscribe({
      next: res => {
        this._loader.setLoaderState(false);
        if (res.status.toLowerCase() === "success") {
          this._toastr.success(res.message, "Success");
          this.closeModal();
          return;
        }

        this._toastr.error(res.message, "Error");
      },
      error: () => {
        this._loader.setLoaderState(false);
      },
    });
  }

  checkDuplicateItem(lines: PurchaseOrderLine[]): Set<string> {
    const itemMap = new Map<string, number>();
    const duplicateItemNumber = new Set<string>();
    for (const line of lines) {
      if (line.itemNumberD365) {
        if (!line.colorD365) {
          line.colorD365 = "";
        }
        if (!line.sizeD365) {
          line.sizeD365 = "";
        }
        if (!line.styleD365) {
          line.styleD365 = "";
        }

        if (
          itemMap.get(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`
          )
        ) {
          duplicateItemNumber.add(line.itemNumberD365);
        } else {
          itemMap.set(
            `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`,
            (itemMap.get(
              `${line.itemNumberD365}${line.styleD365}${line.sizeD365}${line.colorD365}`
            ) ?? 0) + 1
          );
        }
      }
    }

    return duplicateItemNumber;
  }

  calculateNet() {
    let sumOfLineAmount = 0;
    this.servicesTemplateGrid.filteredServiceLines
      .filter(x => !x.excludedD365)
      .forEach(x => {
        if (x.currencyCodeD365?.toLowerCase() == "usd") {
          sumOfLineAmount = sumOfLineAmount + (x.lineAmountD365 ?? 0);
        } else {
          sumOfLineAmount = x.amountInTransactionCurrency
            ? sumOfLineAmount + (x.amountInTransactionCurrency ?? 0)
            : sumOfLineAmount + (x.lineAmountD365 ?? 0);
        }
      });

    let totalQuantity = 0;
    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.forEach(
      x =>
        (totalQuantity = totalQuantity + (x.orderedPurchaseQuantityD365 ?? 0))
    );

    this.finishedGoodsTemplateGrid.filteredFinishedGoodsList.forEach(x => {
      this.finishedGoodsTemplateGrid.onNetConversion(
        (sumOfLineAmount / totalQuantity).toString(),
        x
      );
    });
  }
}
